/*
与后台交互模块 （依赖已封装的ajax函数）
 */
import ajax from './ajax'

// const BASE_ADDRESS_URL = 'http://localhost:8080/a'
// const BASE_POST_SALE_URL = 'http://localhost:8080/c'
// export const BASE_POST_SALE_PIC_URL = 'http://172.30.80.42:4000/pic/'



const BASE_ADDRESS_URL = 'https://mall.jzjsnm.cn/prod/address'
const BASE_POST_SALE_URL = 'https://mall.jzjsnm.cn/prod'
export const BASE_POST_SALE_PIC_URL = 'https://mall.jzjsnm.cn/prod/pic/'


// const BASE_ADDRESS_URL = 'http://172.25.88.58:18089'
// const BASE_POST_SALE_URL = 'http://172.25.88.58:8881'
// export const BASE_POST_SALE_PIC_URL = 'http://172.30.80.42:4000/pic/'


export const getAddressListByUserId = userId => ajax(`${BASE_ADDRESS_URL}/api/account/address/list/${userId}`)


export const deleteAddressById = addressId => ajax(`${BASE_ADDRESS_URL}/api/account/address/delete/${addressId}`)

export const setDefaultAddressById = addressId => ajax(`${BASE_ADDRESS_URL}/api/account/address/setDefault/${addressId}`)

export const getAllProvincesCitysDistricts = () => ajax(`${BASE_ADDRESS_URL}/api/system/address/all`)

export const saveAddress = (phone, name, province, city, district, address, provinceCode, cityCode, districtCode, accountId) => ajax(`${BASE_ADDRESS_URL}/api/account/address/save`, {phone, name, province, city, district, address, provinceCode, cityCode, districtCode, accountId})


export const updateAddress = (phone, name, province, city, district, address, provinceCode, cityCode, districtCode, accountId, id) => ajax(`${BASE_ADDRESS_URL}/api/account/address/update`, {phone, name, province, city, district, address, provinceCode, cityCode, districtCode, accountId, id})



export const applyAfterSale = ({userId,phone,orderNo,reason,returnExplain,merchandiseId,merchandiseStatus,skuId,returnPic}) => ajax(`${BASE_POST_SALE_URL}/TVMallService/afterSale/applyAfterSale`, {userId,phone,orderNo,reason,returnExplain,merchandiseId,merchandiseStatus,skuId,returnPic}, 'POST')

export const uploadImage = (formData) => ajax(`${BASE_POST_SALE_URL}/TVMallService/afterSale/upload/image`, formData, 'POST')


